export const ListQueryKey = 'ActivityZlReward';
export const DetailQueryKey = 'activityRecommendRecord';
export const Urls = {
  selectUrl: '/ZlQyRecord/list',
  updateUrl: '/ZlQyRecord/update',
  deleteUrl: '/ZlQyRecord/delete',
  createUrl: '/ZlQyRecord/create',
  detailUrl: '/ZlQyRecord/info'
}; // /api/ZlQyRecord/list